module.exports = __webpack_public_path__ + "static/media/05.9aa32116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/05.jpg
// module id = 180
// module chunks = 0